import { useMutation } from '@tanstack/react-query';
import { Col, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { memo, useState } from 'react';

import { SaleDealApi } from 'apis/SaleDealApis';
import { FormFilter, SelectForm } from 'components';
import LazySelectForm, {
  ILazySelectData,
  initLazySelectData,
} from 'components/Select/LazySelectForm';
import { IGetListSaleDealParams } from 'interfaces/SaleDeal';
import Content from 'layouts/Content';

interface IProps {
  isOpen: boolean;
  onCancel: () => void;
  onFinish: (values: any) => void;
}

const statusOptions: any[] = [
  { label: 'Hoạt động', value: true },
  { label: 'Không hoạt động', value: false },
];

const spanCol = 8;

const FilterSaleDeal = ({ isOpen, onFinish, onCancel }: IProps) => {
  const [form] = useForm();

  const [saleDealData, setSaleDealData] =
    useState<ILazySelectData>(initLazySelectData);

  const [conditionTypeData, setConditionTypeData] =
    useState<ILazySelectData>(initLazySelectData);

  const { isPending: getListSaleDealCbLoading, mutate: getListSaleDealCb } =
      useMutation({
        mutationFn: (params: IGetListSaleDealParams) =>
          SaleDealApi.getListSaleDealCb(params),
        onSuccess: (res) => {
          const items = res.data?.getVoucher?.items ?? [],
            totalItems = res.data?.getVoucher?.pageInfo?.totalItems;

          const options =
            items.length > 0
              ? items.map((item: any) => ({
                  value: item.saleDeal,
                  label: `${item.saleDeal} - ${item.saleDealName}`,
                }))
              : [];

          setSaleDealData({ options: options, totalItems: totalItems });
        },
        onError: (error) => {
          console.log(error);
        },
      }),
    { isPending: getListConditionTypeLoading, mutate: getListConditionTypeCb } =
      useMutation({
        mutationFn: (params: IGetListSaleDealParams) =>
          SaleDealApi.getListConditionTypeCb(params),
        onSuccess: (res) => {
          const items = res.data?.getConditionType?.items ?? [],
            totalItems = res.data?.getConditionType?.pageInfo?.totalItems;

          const options =
            items.length > 0
              ? items.map((item: any) => ({
                  value: item.id,
                  label: `${item.id} - ${item.name}`,
                }))
              : [];

          setConditionTypeData({ options: options, totalItems: totalItems });
        },
        onError: (error) => {
          console.log(error);
        },
      });

  const handleFinish = () => {
    const values = form.getFieldsValue();
    onFinish(values);
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleSaleDealScrollChange = (params: any) => {
    getListSaleDealCb(params);
  };
  const handleConditionTypeScrollChange = (params: any) => {
    getListConditionTypeCb(params);
  };

  return (
    <Content isOpen={isOpen}>
      <FormFilter form={form} onFinish={handleFinish} onCancel={handleCancel}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="CTKM" name="saleDeal">
              <LazySelectForm
                data={saleDealData}
                placeholder="Chọn CTKM"
                loading={getListSaleDealCbLoading}
                onSelectScrollChange={handleSaleDealScrollChange}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Loại CK" name="conditionType">
              <LazySelectForm
                data={conditionTypeData}
                placeholder="Chọn CTKM"
                loading={getListConditionTypeLoading}
                onSelectScrollChange={handleConditionTypeScrollChange}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Trạng thái" name="status">
              <SelectForm
                options={statusOptions}
                placeholder="Chọn trạng thái"
              />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default memo(FilterSaleDeal);
